export const syncedStatusPageListHeader = [];
